define(["dojo/domReady","/local/buildagent/work/bab00163f105c0e5/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js",""], function(loader, runner) {
   return runner(loader, "", __webpack_require__.dj.c(), true);
});